<template>
  <v-dialog v-model="dialog" persistent max-width="600px" fullscreen>
    <v-card>
      <v-toolbar id="scrollToTop">
        <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-form ref="form" v-model="valid" class="pa-4" lazy-validation>
        <v-card-subtitle class="overline px-0 pb-2 white--text">{{
          $t("insertNewGroupName")
        }}</v-card-subtitle>
        <v-row no-gutters>
          <v-col cols="12" md="4" sm="12">
            <v-text-field
              v-model="groupName"
              :rules="required"
              :label="$t('groupName')"
              outlined
              required
              dense
              autofocus
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-card-subtitle class="overline px-0 pb-2 white--text">{{
            $t("selectPermissions")
          }}</v-card-subtitle>
          <v-spacer></v-spacer>
          <!-- Select All Permissions -->
          <v-checkbox
            v-model="allSelected"
            :label="$t('all')"
            class="mr-1"
            off-icon="mdi-checkbox-blank-outline grey--text text-darken-2"
            @click="selectAllPermissions()"
          >
          </v-checkbox>
        </v-row>
        <!-- Cards Menus: 1. skeleton-loader 2. Cards -->
        <v-row no-gutters>
          <v-col v-if="groupedByMenu.length <= 0" cols="12" md="12" sd="12">
            <v-skeleton-loader
              class="mb-4"
              elevation="2"
              type="{
                card: image, card-heading, list-item-three-line,
              }"
            ></v-skeleton-loader>

            <v-skeleton-loader
              class="mb-4"
              elevation="2"
              type="{
                card: image, card-heading, list-item-three-line,
              }"
            ></v-skeleton-loader>

            <v-skeleton-loader
              class="mb-4"
              elevation="2"
              type="{
                card: image, card-heading, list-item-three-line,
              }"
            ></v-skeleton-loader>
          </v-col>

          <!-- Cards -->
          <v-col v-else cols="12" md="12" sm="12">
            <v-card
              v-for="menu in groupedByMenu"
              :key="menu.menu_id"
              class="mb-4"
            >
              <!-- menu_name -->
              <v-toolbar dense elevation="0">
                <v-toolbar-title class="body-1">
                  {{ menu.menu_name }}
                </v-toolbar-title>
              </v-toolbar>
              <div
                class="ml-4"
                style="width: auto"
                :style="
                  $vuetify.breakpoint.smAndDown
                    ? 'display: flex; flex-direction: column;'
                    : 'display: inline-block;'
                "
                v-for="permission in menu.permissions"
                :key="permission.permissions"
              >
                <div>
                  <v-checkbox
                    v-model="permission.allowed"
                    :label="permission.permission_description"
                    off-icon="mdi-checkbox-blank-outline grey--text text-darken-2"
                    @click="insertPermission(permission)"
                  >
                    <template v-slot:label>
                      <div
                        :class="
                          permission.allowed
                            ? 'white--text'
                            : 'grey--text text-darken-2'
                        "
                      >
                        {{ permission.permission_description }}
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
      <!-- <v-divider /> -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn
          class="my-1 mr-2"
          @click="cancelChoice()"
        >
          {{ $t("toCancel") }}
        </v-btn> -->
        <v-btn
          :disabled="!valid || loading"
          :loading="loading"
          class="info my-1 mr-2"
          @click="updateGroup()"
        >
          {{ $t("toSave") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import { validate } from "@/util/validate";
export default {
  name: "views-backoffice-users-editUser",
  data: () => ({
    groupName: "",
    group: "",
    groups: [],

    // Edit
    id: "",

    // Validate
    valid: false,
    show: false,
    show1: false,
    required: [(v) => !!v || "Campo obrigatório"],
    loading: false,
    permission: "",
    permissionsSelected: [],
    allSelected: false,
    groupedByMenu: [],
    checkbox: "",
    permissionsSelectedAll: [],
  }),

  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
    progress() {
      return this.$store.state.feedbackProgress;
    },
  },

  mounted() {
    // Recupedando o id do grupo de permissoes para usar no Editar
    this.group_id = this.$route.query.id_group;

    // Se tiver id do grupo, significa que o btn de editar foi clicado
    // então, entra no if, lista as permissões daquele id e
    // Recupera e injeta o nome do groupo personalizado no input groupName.
    if (this.group_id) {
      this.listEditPermissions();
      this.groupName = this.$route.query.descricao;

      // F5 na rota de editar
      if (!this.dialog) {
        // this.$router.push({ name: "AdministratorCollaboratorPermissions" });
        this.$store.commit("showDialog", true);
      }
    } else {
      this.listAddPermissions();
    }
  },

  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },

  methods: {
    updateGroup() {
      // Validated
      if (!this.$refs.form.validate()) {
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("emptyFields"),
          color: "warning",
        });
        this.scrollToTop();
        return;
      }
      this.loading = true;

      const body = {
        group_name: this.groupName,
      };
      // Cria a variavel endpoint que será manipulada mais à frente
      var endpoint;

      // Se houver group id, entra no if para o editGroups
      if (this.group_id) {
        body.group_id = this.group_id;
        endpoint = "/administrator/groups/editGroup";
      } else {
        endpoint = "/administrator/groups/createGroup";
      }

      // Entra nesse if caso selecione as Permissões individualmente pelo insertPermission
      if (this.permissionsSelected.length > 0) {
        const groupPermissions = {};
        let i = 0;

        for (const id of this.permissionsSelected) {
          groupPermissions[`group_permissions[${i}]`] = id;
          i++;
        }

        Object.assign(body, groupPermissions);
      } else if (this.permissionsSelectedAll.length > 0) {
        // Entra no else if caso a seleção seja pelo selectAllPermissions
        const groupPermissions = {};
        let i = 0;
        for (const id of this.permissionsSelectedAll) {
          groupPermissions[`group_permissions[${i}]`] = id;
          i++;
        }

        Object.assign(body, groupPermissions);
      } else {
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("atLeastOneOption"),
          color: "warning",
        });
        this.scrollToTop();
        this.loading = false;
        return;
      }

      this.$axios
        .post(endpoint, this.$formdata(body))
        .then((response) => {
          if (response.status === 200) {
            // Refresh List Permissions
            this.$store.commit("setRefresh", true);
            this.$store.commit("setFeedbackSnack", {
              msg: response.data.messages,
              color: "success",
            });
            this.closeDialog();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    closeDialog() {
      this.$store.commit("showDialog", false);
    },

    // Tratando os dados após chamar listAddPermissions
    handlePermissionsByGroup(permissions) {
      permissions.forEach((permission) => {
        // Se existir, monta o array de selecionadas para o update
        if (permission.allowed) {
          this.permissionsSelected.push(permission.permissions);
        }

        // Se houver algum permission.allowed false, seta pra false o allSelected
        // Se passar tudo true, seta para true
        const findAllowedFalse = permissions.some(
          (permission) => permission.allowed == false
        );
        if (findAllowedFalse && this.group_id) {
          this.allSelected = false;
        } else if (!findAllowedFalse && this.group_id) {
          this.allSelected = true;
        }
        // Montando os grupos UI
        const sameMenuId = (item) => item.menu_id == permission.menu_id;
        if (this.groupedByMenu.find(sameMenuId)) {
          this.groupedByMenu[
            this.groupedByMenu.findIndex(sameMenuId)
          ].permissions.push({
            permission_id: permission.permissions,
            permission_description: permission.permission_description,
            allowed: permission.allowed ? permission.allowed : false,
          });
        } else {
          this.groupedByMenu.push({
            menu_id: permission.menu_id,
            menu_name: permission.menu_name,
            permissions: [
              {
                permission_id: permission.permissions,
                permission_description: permission.permission_description,
                allowed: permission.allowed ? permission.allowed : false,
              },
            ],
          });
        }
      });
    },

    // Listar todas as permissões quando for ADD um novo grupo
    listAddPermissions() {
      this.$store.commit("setFeedbackProgress", true);
      this.$axios
        .get("/administrator/groups/listAllPermissions")
        .then((response) => {
          if (this.$hasExemptPlayer() === false) {
            const exemptPlayerPermissionsToRemove = ["132"];
            response.data.dados = response.data.dados.filter(
              (permission) =>
                !exemptPlayerPermissionsToRemove.includes(
                  permission.permissions
                )
            );
          }

          this.handlePermissionsByGroup(response.data.dados);
        });
    },

    // Lista as permissões que foram salvas de acordo com
    // o colaborador para o Editar
    listEditPermissions() {
      let body = {
        group_id: this.group_id,
      };
      this.$store.commit("setFeedbackProgress", true);
      this.$axios
        .post(
          "/administrator/groups/listPermissionsByGroupWithDiff",
          this.$formdata(body)
        )
        .then((response) => {
          if (this.$hasExemptPlayer() === false) {
            const exemptPlayerPermissionsToRemove = ["132"];
            response.data.dados = response.data.dados.filter(
              (permission) =>
                !exemptPlayerPermissionsToRemove.includes(
                  permission.permissions
                )
            );
          }
          this.handlePermissionsByGroup(response.data.dados);
        });
    },

    // Insere / Remove as permissões do array
    insertPermission(permission) {
      if (permission.allowed) {
        this.permissionsSelected.push(permission.permission_id);
      } else {
        this.permissionsSelected.some((item, index) => {
          if (item == permission.permission_id) {
            this.permissionsSelected.splice(index, 1);
          }
        });
      }
    },
    // scroll function
    scrollToTop() {
      document
        .getElementById("scrollToTop")
        .scrollIntoView({ behavior: "smooth" });
    },
    selectAllPermissions() {
      this.permissionsSelected = [];

      for (let permissions in this.groupedByMenu) {
        this.groupedByMenu[permissions].permissions.forEach((permission) => {
          if (this.allSelected) {
            permission.allowed = true;
            this.permissionsSelectedAll.push(permission.permission_id);
          } else {
            permission.allowed = false;
            this.permissionsSelectedAll = [];
          }
        });
      }
    },
    // cancelChoice() {
    //   if (this.group_id) {
    //     // this.groupedByMenu = [],
    //     this.permissionsSelected.length = 0
    //     this.listEditPermissions()
    //   } else {
    //     // this.groupedByMenu = [],
    //     this.permissionsSelected.length = 0
    //     this.listAddPermissions()
    //   }
    // },
  },
};
</script>
